import { AutomationVersionStrategy } from "@redotech/crdb-enums/automations/automation-version-strategy";
import * as z from "zod";
import { automationSummarySchema } from "./common";

/** Sets an automation's version strategy. Runs already in flight keep the strategy they started with. */
export const setVersionStrategy = {
  name: "setVersionStrategy" as const,
  input: z.object({
    id: z.string(),
    versionStrategy: z.enum(AutomationVersionStrategy),
  }),
  output: z.object({ automation: automationSummarySchema }),
};
